import { FC } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const Loader: FC<{ size?: number }> = ({ size }) => {
  return (
    <Box sx={{ display: 'flex' }}>
      <CircularProgress size={size ? size : 40} />
    </Box>
  );
};

export default Loader;
